import React from 'react'
import {
  ClinicCounterBodyDoctorDetails,
  MentorAvatarImg,
  MentorAvatarPlaceholder,
  MentorAvatarWrap,
  PresenceBadge,
} from '../../ClinicCounterStyles'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'

function getInitials(mentor) {
  if (!mentor) return '?'
  const first = mentor?.firstName || mentor?.name || ''
  const last = mentor?.lastName || ''
  if (first && last) return `${first[0]}${last[0]}`.toUpperCase()
  if (first) return first.slice(0, 2).toUpperCase()
  return '?'
}

export default function OneMentorVideoAndOtherMentorCard({
  loading,
  mentor,
  mentorTitle = 'Doctor',
  checkedIn = false,
  hideMentorDetails = false,
  isRightColumn = false,
  children,
}) {
  const displayTitle = mentorTitle || (() => {
    if (mentor?.categories && Array.isArray(mentor.categories)) {
      if (mentor.categories.includes('therapist')) return 'Therapist'
      if (mentor.categories.includes('doctor')) return 'Doctor'
    }
    return 'Practitioner'
  })()

  const hasProfilePic = !hideMentorDetails && mentor?.profilePicId

  return (
    <ClinicCounterBodyDoctorDetails $isRightColumn={isRightColumn}>
      {loading && !mentor ? (
        <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 'clamp(14px, 1.2vw, 18px)' }}>
          Loading...
        </div>
      ) : (
        <>
          {!hideMentorDetails && (
            <MentorAvatarWrap>
              {hasProfilePic ? (
                <MentorAvatarImg
                  src={getImageLink(mentor?.profilePicId)}
                  alt={mentor?.firstName || mentor?.name || 'Practitioner'}
                />
              ) : (
                <MentorAvatarPlaceholder>{getInitials(mentor)}</MentorAvatarPlaceholder>
              )}
              <PresenceBadge present={checkedIn}>
                {checkedIn ? 'उपस्थित' || 'IN' : 'अनुपस्थित' || 'OUT'}
              </PresenceBadge>
            </MentorAvatarWrap>
          )}
          <div
            className="d-flex flex-column"
            style={{
              textAlign: 'center',
              width: '100%',
              color: 'rgba(255,255,255,0.95)',
              gap: '0',
            }}
          >
            {!hideMentorDetails && (
              <div id="screening-mentor-name" style={{ marginBottom: '12px' }}>
                <div
                  style={{
                    fontSize: 'clamp(15px, 1.35vw, 20px)',
                    fontWeight: 700,
                    lineHeight: 1.3,
                    display: 'block',
                    marginBottom: '4px',
                  }}
                >
                  {mentor?.name || [mentor?.firstName, mentor?.lastName].filter(Boolean).join(' ') || '—'}
                </div>
                <div
                  style={{
                    fontSize: 'clamp(12px, 1vw, 15px)',
                    fontWeight: 500,
                    color: 'rgba(255,255,255,0.65)',
                    display: 'block',
                    letterSpacing: '0.02em',
                  }}
                >
                  {displayTitle}
                </div>
              </div>
            )}
            {children && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px',
                  marginTop: hideMentorDetails ? 0 : '8px',
                  paddingTop: hideMentorDetails ? 0 : '12px',
                  borderTop: hideMentorDetails ? 'none' : '1px solid rgba(255,255,255,0.12)',
                }}
              >
                {children}
              </div>
            )}
          </div>
          {hideMentorDetails && (
            <div style={{ marginTop: 'auto' }}>
              <PresenceBadge present={checkedIn}>
                {checkedIn ? 'उपस्थित' || 'IN' : 'अनुपस्थित' || 'OUT'}
              </PresenceBadge>
            </div>
          )}
        </>
      )}
    </ClinicCounterBodyDoctorDetails>
  )
}
